// @flow
import React from 'react';
import { createUseStyles } from 'react-jss';
import type { Styles } from 'shared/types';

export default function Gradient() {
  const c: Styles<typeof styles> = useStyles();

  return <div className={c.gradient} />;
}

const styles = {
  gradient: {
    animation: '$fadeIn 1.5s ease-in-out',
    backgroundImage: 'linear-gradient(rgba(87,87,87,0.5), rgba(0,0,0,.02) 70%, rgba(0,0,0,0))',
    position: 'absolute',
    width: '100%',
    height: '11%',
    top: '0',
    left: '0',
    right: '0',
    '@media(min-height: 500px)': {
      height: '20%'
    },
  },
  '@keyframes fadeIn': {
    from: {
      opacity: '0'
    },
    to: {
      opacity: '1'
    }
  }
};
const useStyles = createUseStyles(styles);
